// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionSummary.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

import connect from 'share/enhancers/Izenda.Connect';

import React, { Component } from 'react';

import uiState from 'logic/Izenda.UiState.js';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import RightPanelContent from './Izenda.RightPanelContent';
import SystemConfiguration from './Izenda.SystemConfiguration';
import TenantSetup from './Izenda.TenantSetup';
import DataSetup from './Izenda.DataSetup';
import UserSetup from './Izenda.UserSetup';
import RoleSetup from './Izenda.RoleSetup';
import Reports from './Izenda.Reports';
import Dashboards from './Izenda.Dashboards';
import Access from './Izenda.Access';
import Scheduling from './Izenda.Scheduling';
import Emailing from './Izenda.Emailing';
import Exporting from './Izenda.Exporting';
import SystemWide from './Izenda.SystemWide';
import { forEach, isEmpty } from 'lodash/fp';
@connect()
export default class PermissionSummary extends Component {
  static propTypes = {
    store: React.PropTypes.object.isRequired
  };

  /**
   * component Will Mount
   */
  constructor(props) {
    super(props);
    const loader = props.loader;
    loader.startLoading();
    props.store.loadPermissionSummary().finally(loader.endLoading.bind(loader));
  }

  renderColumnHeader = () => {
    const { store: { permissionSummaryStore: { model } } } = this.props;

    const header = [];
    forEach(summary => {
      header.push(
        <GridLayout.Col
          cols="1"
          title={summary.name}
          className="grid-small-column u_borderRight u-bgGrayBlue text-bold u_textTruncate"
          key={summary.id}
        >
          {summary.name}
        </GridLayout.Col>
      );
    }, model.permissionSummary);
    return header;
  };

  /**
   * render component
   */
  render() {
    const { localization, store: { permissionSummaryStore: { model } } } = this.props;

    return (
      <div className="izenda-PermissionSummaryTab u_fullHeight u-posBottomLeft u-posAbsolute u_fullWidth u_paddingAll">
        <GridLayout className="u_fullHeight u_fullWidth">
          <GridLayout.Row className="izenda-PermissionSummaryTab-TopRow u_noMarginAll u_noPaddingAll">
            <GridLayout.Col
              cols="12"
              className="u_noMarginAll u_noPaddingAll  izenda-HeaderCustomLabelHeight u_borderAll"
            >
              <GridLayout.Col
                cols="3"
                className="u_paddingLeft u_table u_borderRight u_fullHeight u-bgGrayBlue text-bold"
              >
                <div className="u_tableCell u_alignMiddle">
                  <span
                    className="icon-chevron-down u_noMarginAll u_borderAll u-bgWhite"
                    onClick={model.updateExpendCollapseAll.bind(model, true)}
                  />
                  <span
                    className="icon-chevron-up u_noMarginAll u_borderAll u-bgWhite"
                    onClick={model.updateExpendCollapseAll.bind(model, false)}
                  />
                </div>
                <span className="u_tableCell u_alignMiddle">
                  {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_PERMISSION')}
                </span>
              </GridLayout.Col>

              <GridLayout.Col cols="9" className="u_noPaddingAll u_table text-center">
                <div className="grid-small-column">
                  {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_ROLES')}
                </div>
                <GridLayout.Col cols="12" className="u_noPaddingAll u_borderTop">
                  {!isEmpty(model.permissionSummary) && this.renderColumnHeader()}
                </GridLayout.Col>
              </GridLayout.Col>
            </GridLayout.Col>
          </GridLayout.Row>

          <ScrollBox className="izenda-PermissionSummaryTab-Detail">
            <GridLayout.Row className="u_noMarginAll u_borderAll u_noBorderTop">
              <GridLayout.Col cols="12" className="u_noPaddingAll u-bgGray">
                <GridLayout.Col
                  cols="3"
                  className="grid-small-column u_borderRight u-bgGrayBlue text-bold u_paddingLeft"
                >
                  <div className="u_paddingLeft">
                    {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_FULL_REPORT_AND_DASHBOARD_ACCESS')}
                  </div>
                </GridLayout.Col>

                <RightPanelContent className="u-bgGray" model={model} keysPath="fullReportAndDashboardAccess" />
              </GridLayout.Col>
            </GridLayout.Row>

            <GridLayout.Row className="u_noMarginAll u_borderAll u_noBorderTop">
              <GridLayout.Col cols="12" className="u_noPaddingAll u-bgGray">
                <SystemConfiguration model={model} />
              </GridLayout.Col>
            </GridLayout.Row>

            {uiState.currentUser.isSystemUser && (
              <GridLayout.Row className="u_noMarginAll u_borderAll u_noBorderTop">
                <GridLayout.Col cols="12" className="u_noPaddingAll u-bgGray">
                  <TenantSetup model={model} />
                </GridLayout.Col>
              </GridLayout.Row>
            )}

            <GridLayout.Row className="u_noMarginAll u_borderAll u_noBorderTop">
              <GridLayout.Col cols="12" className="u_noPaddingAll u-bgGray">
                <DataSetup model={model} />
              </GridLayout.Col>
            </GridLayout.Row>

            <GridLayout.Row className="u_noMarginAll u_borderAll u_noBorderTop">
              <GridLayout.Col cols="12" className="u_noPaddingAll u-bgGray">
                <UserSetup model={model} />
              </GridLayout.Col>
            </GridLayout.Row>

            <GridLayout.Row className="u_noMarginAll u_borderAll u_noBorderTop">
              <GridLayout.Col cols="12" className="u_noPaddingAll u-bgGray">
                <RoleSetup model={model} />
              </GridLayout.Col>
            </GridLayout.Row>

            <GridLayout.Row className="u_noMarginAll u_borderAll u_noBorderTop">
              <GridLayout.Col cols="12" className="u_noPaddingAll u-bgGray">
                <Reports model={model} />
              </GridLayout.Col>
            </GridLayout.Row>

            <GridLayout.Row className="u_noMarginAll u_borderAll u_noBorderTop">
              <GridLayout.Col cols="12" className="u_noPaddingAll u-bgGray">
                <Dashboards model={model} />
              </GridLayout.Col>
            </GridLayout.Row>

            <GridLayout.Row className="u_noMarginAll u_borderAll u_noBorderTop">
              <GridLayout.Col cols="12" className="u_noPaddingAll u-bgGray">
                <Access model={model} />
              </GridLayout.Col>
            </GridLayout.Row>

            <GridLayout.Row className="u_noMarginAll u_borderAll u_noBorderTop">
              <GridLayout.Col cols="12" className="u_noPaddingAll u-bgGray ">
                <Scheduling model={model} />
              </GridLayout.Col>
            </GridLayout.Row>

            <GridLayout.Row className="u_noMarginAll u_borderAll u_noBorderTop">
              <GridLayout.Col cols="12" className="u_noPaddingAll u-bgGray">
                <Emailing model={model} />
              </GridLayout.Col>
            </GridLayout.Row>

            <GridLayout.Row className="u_noMarginAll u_borderAll u_noBorderTop">
              <GridLayout.Col cols="12" className="u_noPaddingAll u-bgGray">
                <Exporting model={model} />
              </GridLayout.Col>
            </GridLayout.Row>

            <GridLayout.Row className="u_noMarginAll u_borderAll u_noBorderTop">
              <GridLayout.Col cols="12" className="u_noPaddingAll u-bgGray">
                <SystemWide model={model} />
              </GridLayout.Col>
            </GridLayout.Row>
          </ScrollBox>
        </GridLayout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/PermissionSummary/Izenda.PermissionSummary.js